module.exports = __webpack_public_path__ + "static/media/google.44b0dca7.png";